import { useTemplateEngine } from './templateEngine/useTemplateEngine';
import { useIsPlgProd } from './useIsPlgProd';

/**
 * Returns true if multi-draft functionality should be enabled.
 * Multi-draft is disabled for:
 * 1. PLG prod environments (useIsPlgProd returns true), OR
 * 2. Template engine projects
 */
export function useIsMultiDraft(): boolean {
  const isPlgProd = useIsPlgProd();
  const { isTemplateEngineEnabled } = useTemplateEngine();

  return !isPlgProd && !isTemplateEngineEnabled;
}
